import { defineStore } from 'pinia'

export const DistrictsList = defineStore({
    id: 'g_dictionary__district_list',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const District__Guid = defineStore({
    id: 'g_dictionary__district_current_guid',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const District__Info = defineStore({
    id: 'g_dictionary__district_current_info',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
